const F = FinalizationRegistry;
export { F as FinalizationRegistry };
